import { render } from "./FileManagerUploadFiles.vue?vue&type=template&id=728cace0&scoped=true"
import script from "./FileManagerUploadFiles.vue?vue&type=script&lang=js"
export * from "./FileManagerUploadFiles.vue?vue&type=script&lang=js"

import "./FileManagerUploadFiles.vue?vue&type=style&index=0&id=728cace0&scoped=true&lang=css"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728cace0"]])

export default __exports__